<template>
  <a-pagination
    v-model="current"
    :show-total="newtotal => `共 ${newtotal} 条`"
    :page-size-options="pageSizeOptions"
    :total="total"
    show-size-changer
    :page-size="pageSize"
    @showSizeChange="onShowSizeChange"
    @change="onChange"
    size="small"
  >
  </a-pagination>
</template>
<script>
export default {
  name: "TablePages",
  props: ["current", "pageSize", "total"],
  data() {
    return {
      pageSizeOptions: ["10", "20", "30", "40", "50", "100", "200", "500"],
    };
  },
  created() {},
  methods: {
    onChange(page, pageSize) {
      const newPage = {
        current: page,
        pageSize: pageSize,
      };
      this.$emit("changePage", newPage);
    },
    onShowSizeChange(current, pageSize) {
      const newPage = {
        current: current,
        pageSize: pageSize,
      };
      this.$emit("changePage", newPage);
    },
  },
};
</script>

<style lang="less" scoped></style>
